module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#thump",
      toString: function () {
        return this.url;
      }
    }